<ion-header>
    <ion-toolbar>
        <ion-title>{{ step === 1 ? 'Locatie' : 'Meldingen' }}</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
    <div class="onboarding-step" *ngIf="step === 1" data-testid="permissions-onboarding-location">
        <div class="onboarding-icon-halo">
            <ion-icon name="location" class="onboarding-icon" aria-hidden="true"></ion-icon>
        </div>
        <h2 class="text-center">Speel jij in de buurt?</h2>
        <p class="text-center onboarding-intro">Met je locatie kunnen we je helpen met:</p>
        <div class="helper-text">
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Spelers in de buurt vinden</p>
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Toernooien bij jou in de buurt</p>
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Automatisch inchecken bij een poolcentrum</p>
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Pushmeldingen voor evenementen bij jou in de buurt</p>
        </div>
        <p class="onboarding-note text-center">Je toestel vraagt je hierna om toestemming voor je locatie.</p>
    </div>

    <div class="onboarding-step" *ngIf="step === 2" data-testid="permissions-onboarding-push">
        <div class="onboarding-icon-halo">
            <ion-icon name="notifications" class="onboarding-icon" aria-hidden="true"></ion-icon>
        </div>
        <h2 class="text-center">Niks missen?</h2>
        <p class="text-center onboarding-intro">Schakel meldingen in om op de hoogte te blijven van:</p>
        <div class="helper-text">
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Nieuwe uitdagingen en toernooi-uitnodigingen</p>
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Wanneer jij aan de beurt bent</p>
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Uitslagen van gevolgde spelers en teams</p>
            <p><ion-icon name="checkmark-circle" class="color-green" aria-hidden="true"></ion-icon> Herinneringen vlak voordat je partij begint</p>
        </div>
        <p class="onboarding-note text-center">Je toestel vraagt je hierna om toestemming voor meldingen.</p>
    </div>
</ion-content>
<ion-footer no-shadow no-border class="ion-padding">
    <ng-container *ngIf="step === 1">
        <ion-button expand="block" fill="outline" color="medium" data-testid="permissions-onboarding-location-deny" (click)="chooseLocation(false)">Niet nu</ion-button>
        <ion-button expand="block" color="primary" class="onboarding-cta" data-testid="permissions-onboarding-location-allow" (click)="chooseLocation(true)">Ja, doorgaan</ion-button>
    </ng-container>
    <ng-container *ngIf="step === 2">
        <ion-button expand="block" fill="outline" color="medium" data-testid="permissions-onboarding-push-deny" (click)="choosePush(false)">Niet nu</ion-button>
        <ion-button expand="block" color="primary" class="onboarding-cta" data-testid="permissions-onboarding-push-allow" (click)="choosePush(true)">Ja, doorgaan</ion-button>
    </ng-container>
</ion-footer>
